import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
const Badge = ({ className, text, onClick, type, showDelete, dataTestId }) => {
    const classNames = getClassNames(type);
    const containerClassName = classnames(Object.assign(Object.assign({}, classNames.container), className));
    return (React.createElement("div", { className: containerClassName },
        React.createElement("span", { className: classnames(classNames.text), "data-testid": dataTestId || "badge" }, text),
        showDelete && (React.createElement("a", { href: "#", className: classnames(classNames.link), onClick: (e) => {
                e.preventDefault();
                onClick();
            } },
            React.createElement("svg", { className: "w-2 h-2", stroke: "currentColor", fill: "none", viewBox: "0 0 8 8" },
                React.createElement("path", { strokeLinecap: "round", strokeWidth: "1.5", d: "M1 1l6 6m0-6L1 7" }))))));
};
Badge.propTypes = {
    className: PropTypes.object,
    showDelete: PropTypes.bool,
    type: PropTypes.string,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func,
};
Badge.defaultProps = {
    className: {},
    onClick: () => { },
    showDelete: true,
};
const defaultLinkClassName = {
    flex: true,
    'items-center': true,
};
const defaultContainerClassName = {
    border: true,
    'border-solid': true,
    'items-center': true,
    'leading-none': true,
    'px-3 py-1': true,
    flex: true,
    'flex-shrink-0': true,
    'justify-center': true,
    'rounded-full': true,
};
const defaultTextClassName = {
    'font-medium': true,
    'text-left': true,
    'text-sm': true,
    block: true,
    'mr-2': true,
};
function getClassNames(type) {
    switch (type) {
        case 'black':
            return {
                container: Object.assign(Object.assign({}, defaultContainerClassName), { 'bg-black': true, 'border-black': true }),
                text: Object.assign(Object.assign({}, defaultTextClassName), { 'text-white': true }),
                link: Object.assign(Object.assign({}, defaultLinkClassName), { 'text-white': true }),
            };
        case 'green':
            return {
                container: Object.assign(Object.assign({}, defaultContainerClassName), { 'bg-green': true, 'border-green': true }),
                text: Object.assign(Object.assign({}, defaultTextClassName), { 'text-white': true }),
                link: Object.assign(Object.assign({}, defaultLinkClassName), { 'text-white': true }),
            };
        default:
            return {
                container: Object.assign(Object.assign({}, defaultContainerClassName), { 'bg-white': true, 'border-green': true }),
                text: Object.assign(Object.assign({}, defaultTextClassName), { 'text-green': true }),
                link: Object.assign(Object.assign({}, defaultLinkClassName), { 'text-green': true }),
            };
    }
}
export default Badge;
